import { Event } from '@/types/event';
import { EventTicketType } from '@/types/eventTicketType';

export class EventHelper {
  static isExpired(event: Event): boolean {
    if (!event.dateTo) return false;

    const endDate =
      typeof event.dateTo === 'string' ? new Date(event.dateTo) : event.dateTo;
    const currentTime = new Date();
    return currentTime > endDate;
  }

  static isSoldOut(eventTicketTypes: EventTicketType[]) {
    if (!eventTicketTypes) return true;
    return eventTicketTypes.every((e) => e.ticketsLeft && e.ticketsLeft <= 0);
  }

  static isPublished(event: Event) {
    if (!event.publishedAt) return true;

    return new Date(event.publishedAt) < new Date();
  }
}
